import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, from } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Globals } from 'src/app/common/globals';
import { Geolocation } from 'src/app/common/model/geolocation';
import { LocationsMapComponent } from './locations-map.component';

@Component({
  selector: 'locations-map-dialog',
  templateUrl: './locations-map-dialog.component.html',
  styleUrls: ['./locations-map-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsMapDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('locationsMapComponent', {static: false}) locationsMapComponent: LocationsMapComponent;


  private geolGrantedSubj = new BehaviorSubject<boolean>(false);
  geolocationGranted$ = this.geolGrantedSubj.asObservable();
  private permStatus?: PermissionStatus;
  constructor(@Inject(MAT_DIALOG_DATA) public data: LocationMapData,
              private cd: ChangeDetectorRef,
              private globals: Globals,
              private zone: NgZone,
              private dialogRef: MatDialogRef<LocationsMapDialogComponent>) {
  }

  ngAfterViewInit(): void {
  }

  async ngOnInit(): Promise<void> {
    this.geolGrantedSubj.next(await this.geolocationEnabled());

    if ('permissions' in navigator) {
      this.permStatus = await navigator.permissions.query({ name: 'geolocation' as PermissionName });
      this.geolGrantedSubj.next(this.permStatus.state === 'granted');

      this.permStatus.onchange = () => {
        const g = this.permStatus!.state === 'granted';
        this.zone.run(() => {
          this.geolGrantedSubj.next(g);
          this.setupMap(g);
        });
      };
    }
  }

  ngOnDestroy(): void {
    if (this.permStatus) this.permStatus.onchange = null;
  }

  reloadPage() {
    window.location.reload();
  }

  async geolocationEnabled(): Promise<boolean> {
    if (!('permissions' in navigator)) return false;
    try {
      const s = await navigator.permissions.query({ name: 'geolocation' });
      return s.state === 'granted';
    } catch { return false; }
  }

  private async setupMap(allowed: boolean){
    if(allowed){
      navigator.geolocation.getCurrentPosition(async (position) => {
          this.globals.lastPosition = position;
          await this.locationsMapComponent.setupMap(position);
      });
    }
    return;
  }

}



export interface LocationMapData {
  showOnlyUserRelated: boolean;
  highlightedLocationIDs: number[];
  centerToPosition: Geolocation.GeolocationCoordinates;
}